// import axios from 'axios';
// export default axios;

import axios_mock from '../crud/mock/axios';
export default axios_mock;
